/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Recap
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import { useApiFetch } from '../client.ts';
import type { ErrorType } from '../client.ts';
import { useMutationBehavior } from '../mutations.ts';
import { useQueryBehavior } from '../queries.ts';
import { Attention, EmployeeAttention, EmployeeRecapNews, RecapNews } from './schemas.ts';
import type { ErrorResponse } from './schemas.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getGetAttentionUrl = () => {
    return `/workspace/attention`;
};

/**
 * @summary Get Attention
 */
export const useGetAttentionHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Attention>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetAttentionUrl(), {
            ...options,
            method: 'GET',

            schema: Attention,
        });
    };
};

export const getGetAttentionQueryKey = () => {
    return ['workspace', 'attention'] as const;
};

export const useGetAttentionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAttentionQueryKey();

    const getAttention = useGetAttentionHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>> = ({ signal }) =>
        getAttention({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/attention`, operationId: 'get_attention', operationName: 'getAttention' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAttentionQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>>;
export type GetAttentionQueryError = ErrorType<ErrorResponse>;

export function useGetAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Attention
 */

export function useGetAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAttentionHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetAttentionQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getVisitSectionUrl = (section: 'home' | 'activities' | 'recaps' | 'sources') => {
    return `/workspace/visits/${section}`;
};

/**
 * @summary Visit Section
 */
export const useVisitSectionHook = (): ((
    section: 'home' | 'activities' | 'recaps' | 'sources',
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (
        section: 'home' | 'activities' | 'recaps' | 'sources',
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getVisitSectionUrl(section), {
            ...options,
            method: 'POST',
        });
    };
};

export const getVisitSectionMutationKey = () => ['visitSection'] as const;

export const useVisitSectionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>,
        TError,
        VisitSectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>,
    TError,
    VisitSectionMutationVariables,
    TContext
> => {
    const mutationKey = getVisitSectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const visitSection = useVisitSectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>,
        VisitSectionMutationVariables
    > = (props) => {
        const { section } = props ?? {};

        return visitSection(section, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/visits/{section}` },
        { operationId: 'visit_section', operationName: 'visitSection' }
    );

    return customOptions;
};

export type VisitSectionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>>;

export type VisitSectionMutationError = ErrorType<ErrorResponse>;
export type VisitSectionMutationVariables = { section: 'home' | 'activities' | 'recaps' | 'sources' };

/**
 * @summary Visit Section
 */
export const useVisitSection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>,
            TError,
            VisitSectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useVisitSectionHook>>>,
    TError,
    VisitSectionMutationVariables,
    TContext
> => {
    return useMutation(useVisitSectionMutationOptions(options), queryClient);
};
export const getMarkSectionSeenUrl = (section: 'home' | 'activities' | 'recaps' | 'sources') => {
    return `/workspace/visits/${section}/seen`;
};

/**
 * @summary Mark Section Seen
 */
export const useMarkSectionSeenHook = (): ((
    section: 'home' | 'activities' | 'recaps' | 'sources',
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (
        section: 'home' | 'activities' | 'recaps' | 'sources',
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getMarkSectionSeenUrl(section), {
            ...options,
            method: 'POST',
        });
    };
};

export const getMarkSectionSeenMutationKey = () => ['markSectionSeen'] as const;

export const useMarkSectionSeenMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>,
        TError,
        MarkSectionSeenMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>,
    TError,
    MarkSectionSeenMutationVariables,
    TContext
> => {
    const mutationKey = getMarkSectionSeenMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const markSectionSeen = useMarkSectionSeenHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>,
        MarkSectionSeenMutationVariables
    > = (props) => {
        const { section } = props ?? {};

        return markSectionSeen(section, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/visits/{section}/seen` },
        { operationId: 'mark_section_seen', operationName: 'markSectionSeen' }
    );

    return customOptions;
};

export type MarkSectionSeenMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>>;

export type MarkSectionSeenMutationError = ErrorType<ErrorResponse>;
export type MarkSectionSeenMutationVariables = { section: 'home' | 'activities' | 'recaps' | 'sources' };

/**
 * @summary Mark Section Seen
 */
export const useMarkSectionSeen = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>,
            TError,
            MarkSectionSeenMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useMarkSectionSeenHook>>>,
    TError,
    MarkSectionSeenMutationVariables,
    TContext
> => {
    return useMutation(useMarkSectionSeenMutationOptions(options), queryClient);
};
export const getVisitRecapUrl = (publicId: string) => {
    return `/workspace/recaps/${publicId}/visit`;
};

/**
 * @summary Visit Recap
 */
export const useVisitRecapHook = (): ((
    publicId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (publicId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getVisitRecapUrl(publicId), {
            ...options,
            method: 'POST',
        });
    };
};

export const getVisitRecapMutationKey = () => ['visitRecap'] as const;

export const useVisitRecapMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>,
        TError,
        VisitRecapMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>,
    TError,
    VisitRecapMutationVariables,
    TContext
> => {
    const mutationKey = getVisitRecapMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const visitRecap = useVisitRecapHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>,
        VisitRecapMutationVariables
    > = (props) => {
        const { publicId } = props ?? {};

        return visitRecap(publicId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/recaps/{publicId}/visit` },
        { operationId: 'visit_recap', operationName: 'visitRecap' }
    );

    return customOptions;
};

export type VisitRecapMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>>;

export type VisitRecapMutationError = ErrorType<ErrorResponse>;
export type VisitRecapMutationVariables = { publicId: string };

/**
 * @summary Visit Recap
 */
export const useVisitRecap = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>,
            TError,
            VisitRecapMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useVisitRecapHook>>>,
    TError,
    VisitRecapMutationVariables,
    TContext
> => {
    return useMutation(useVisitRecapMutationOptions(options), queryClient);
};
export const getGetRecapNewsUrl = (publicId: string | null) => {
    return `/workspace/recaps/${publicId}/news`;
};

/**
 * @summary Get Recap News
 */
export const useGetRecapNewsHook = (): ((
    publicId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<RecapNews>) => {
    const customFetcher = useApiFetch();
    return (publicId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetRecapNewsUrl(publicId), {
            ...options,
            method: 'GET',

            schema: RecapNews,
        });
    };
};

export const getGetRecapNewsQueryKey = (publicId: string | null) => {
    return ['workspace', 'recaps', publicId, 'news'] as const;
};

export const useGetRecapNewsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRecapNewsQueryKey(publicId);

    const getRecapNews = useGetRecapNewsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>> = ({ signal }) =>
        getRecapNews(publicId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: publicId !== null && publicId !== undefined, ...queryOptions },
        { publicId },
        { url: `/workspace/recaps/${publicId}/news`, operationId: 'get_recap_news', operationName: 'getRecapNews' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRecapNewsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>>;
export type GetRecapNewsQueryError = ErrorType<ErrorResponse>;

export function useGetRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Recap News
 */

export function useGetRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRecapNewsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetRecapNewsQueryOptions(publicId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getVisitSourceUrl = (sourceId: string) => {
    return `/workspace/sources/${sourceId}/visit`;
};

/**
 * @summary Visit Source
 */
export const useVisitSourceHook = (): ((
    sourceId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (sourceId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getVisitSourceUrl(sourceId), {
            ...options,
            method: 'POST',
        });
    };
};

export const getVisitSourceMutationKey = () => ['visitSource'] as const;

export const useVisitSourceMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>,
        TError,
        VisitSourceMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>,
    TError,
    VisitSourceMutationVariables,
    TContext
> => {
    const mutationKey = getVisitSourceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const visitSource = useVisitSourceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>,
        VisitSourceMutationVariables
    > = (props) => {
        const { sourceId } = props ?? {};

        return visitSource(sourceId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/sources/{sourceId}/visit` },
        { operationId: 'visit_source', operationName: 'visitSource' }
    );

    return customOptions;
};

export type VisitSourceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>>;

export type VisitSourceMutationError = ErrorType<ErrorResponse>;
export type VisitSourceMutationVariables = { sourceId: string };

/**
 * @summary Visit Source
 */
export const useVisitSource = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>,
            TError,
            VisitSourceMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useVisitSourceHook>>>,
    TError,
    VisitSourceMutationVariables,
    TContext
> => {
    return useMutation(useVisitSourceMutationOptions(options), queryClient);
};
export const getGetEmployeeAttentionUrl = () => {
    return `/workspace/client/attention`;
};

/**
 * @summary Get Employee Attention
 */
export const useGetEmployeeAttentionHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<EmployeeAttention>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetEmployeeAttentionUrl(), {
            ...options,
            method: 'GET',

            schema: EmployeeAttention,
        });
    };
};

export const getGetEmployeeAttentionQueryKey = () => {
    return ['workspace', 'client', 'attention'] as const;
};

export const useGetEmployeeAttentionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEmployeeAttentionQueryKey();

    const getEmployeeAttention = useGetEmployeeAttentionHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>> = ({ signal }) =>
        getEmployeeAttention({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        {
            url: `/workspace/client/attention`,
            operationId: 'get_employee_attention',
            operationName: 'getEmployeeAttention',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmployeeAttentionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>
>;
export type GetEmployeeAttentionQueryError = ErrorType<ErrorResponse>;

export function useGetEmployeeAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmployeeAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmployeeAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Employee Attention
 */

export function useGetEmployeeAttention<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeAttentionHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetEmployeeAttentionQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getVisitEmployeeSectionUrl = (section: 'home' | 'recaps') => {
    return `/workspace/client/visits/${section}`;
};

/**
 * @summary Visit Employee Section
 */
export const useVisitEmployeeSectionHook = (): ((
    section: 'home' | 'recaps',
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (section: 'home' | 'recaps', options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getVisitEmployeeSectionUrl(section), {
            ...options,
            method: 'POST',
        });
    };
};

export const getVisitEmployeeSectionMutationKey = () => ['visitEmployeeSection'] as const;

export const useVisitEmployeeSectionMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>,
        TError,
        VisitEmployeeSectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>,
    TError,
    VisitEmployeeSectionMutationVariables,
    TContext
> => {
    const mutationKey = getVisitEmployeeSectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const visitEmployeeSection = useVisitEmployeeSectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>,
        VisitEmployeeSectionMutationVariables
    > = (props) => {
        const { section } = props ?? {};

        return visitEmployeeSection(section, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/visits/{section}` },
        { operationId: 'visit_employee_section', operationName: 'visitEmployeeSection' }
    );

    return customOptions;
};

export type VisitEmployeeSectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>
>;

export type VisitEmployeeSectionMutationError = ErrorType<ErrorResponse>;
export type VisitEmployeeSectionMutationVariables = { section: 'home' | 'recaps' };

/**
 * @summary Visit Employee Section
 */
export const useVisitEmployeeSection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>,
            TError,
            VisitEmployeeSectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeSectionHook>>>,
    TError,
    VisitEmployeeSectionMutationVariables,
    TContext
> => {
    return useMutation(useVisitEmployeeSectionMutationOptions(options), queryClient);
};
export const getVisitEmployeeRecapUrl = (publicId: string) => {
    return `/workspace/client/recaps/${publicId}/visit`;
};

/**
 * @summary Visit Employee Recap
 */
export const useVisitEmployeeRecapHook = (): ((
    publicId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (publicId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getVisitEmployeeRecapUrl(publicId), {
            ...options,
            method: 'POST',
        });
    };
};

export const getVisitEmployeeRecapMutationKey = () => ['visitEmployeeRecap'] as const;

export const useVisitEmployeeRecapMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>,
        TError,
        VisitEmployeeRecapMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>,
    TError,
    VisitEmployeeRecapMutationVariables,
    TContext
> => {
    const mutationKey = getVisitEmployeeRecapMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const visitEmployeeRecap = useVisitEmployeeRecapHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>,
        VisitEmployeeRecapMutationVariables
    > = (props) => {
        const { publicId } = props ?? {};

        return visitEmployeeRecap(publicId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/recaps/{publicId}/visit` },
        { operationId: 'visit_employee_recap', operationName: 'visitEmployeeRecap' }
    );

    return customOptions;
};

export type VisitEmployeeRecapMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>
>;

export type VisitEmployeeRecapMutationError = ErrorType<ErrorResponse>;
export type VisitEmployeeRecapMutationVariables = { publicId: string };

/**
 * @summary Visit Employee Recap
 */
export const useVisitEmployeeRecap = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>,
            TError,
            VisitEmployeeRecapMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useVisitEmployeeRecapHook>>>,
    TError,
    VisitEmployeeRecapMutationVariables,
    TContext
> => {
    return useMutation(useVisitEmployeeRecapMutationOptions(options), queryClient);
};
export const getGetEmployeeRecapNewsUrl = (publicId: string | null) => {
    return `/workspace/client/recaps/${publicId}/news`;
};

/**
 * @summary Get Employee Recap News
 */
export const useGetEmployeeRecapNewsHook = (): ((
    publicId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<EmployeeRecapNews>) => {
    const customFetcher = useApiFetch();
    return (publicId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetEmployeeRecapNewsUrl(publicId), {
            ...options,
            method: 'GET',

            schema: EmployeeRecapNews,
        });
    };
};

export const getGetEmployeeRecapNewsQueryKey = (publicId: string | null) => {
    return ['workspace', 'client', 'recaps', publicId, 'news'] as const;
};

export const useGetEmployeeRecapNewsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEmployeeRecapNewsQueryKey(publicId);

    const getEmployeeRecapNews = useGetEmployeeRecapNewsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>> = ({ signal }) =>
        getEmployeeRecapNews(publicId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: publicId !== null && publicId !== undefined, ...queryOptions },
        { publicId },
        {
            url: `/workspace/client/recaps/${publicId}/news`,
            operationId: 'get_employee_recap_news',
            operationName: 'getEmployeeRecapNews',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmployeeRecapNewsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>
>;
export type GetEmployeeRecapNewsQueryError = ErrorType<ErrorResponse>;

export function useGetEmployeeRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmployeeRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmployeeRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Employee Recap News
 */

export function useGetEmployeeRecapNews<
    TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    publicId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeRecapNewsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetEmployeeRecapNewsQueryOptions(publicId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
